import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export const FloatingControls = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Toggle visibility of Back to Top button
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const whatsappNumber = "447724009805";
  const whatsappMessage = "Hello Simba Herbals, I would like to know more about your products.";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <div className="fixed bottom-8 right-8 flex flex-col items-center gap-4 z-50">
      {/* Back to Top Button */}
      <button
        type="button"
        onClick={scrollToTop}
        className={`bg-simba-gold text-simba-dark p-3 rounded-full shadow-lg hover:bg-white hover:scale-110 transition-all duration-300 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
        }`}
        aria-label="Back to Top"
      >
        <ArrowUp size={24} strokeWidth={2} />
      </button>

      {/* WhatsApp Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="group bg-[#25D366] text-white p-3 rounded-full shadow-lg hover:bg-[#128C7E] hover:scale-110 transition-all duration-300 flex items-center gap-0 hover:gap-2 hover:pr-6"
        aria-label="Chat on WhatsApp"
        title="Chat with us on WhatsApp"
      >
        <WhatsAppIcon sx={{ fontSize: 28 }} />
        <span className="max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-500 ease-in-out whitespace-nowrap text-sm font-bold">
          Chat with us
        </span>
      </a>
    </div>
  );
};
